import { Trans, useLingui } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconInfo from '@/icons/Info.svg';
import { REQUEST_WAIVE_HANDLING_FEE_REASONS } from '@/models/request';

export const RequestHandlingFeeWaivedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_handling_fee_waived'>;
}) => {
  const { i18n } = useLingui();

  let creatorName = activity.creator.name;

  if (activity.data.salesAdvisor) {
    creatorName += ` (${activity.data.salesAdvisor})`;
  }

  const reasonLabel = REQUEST_WAIVE_HANDLING_FEE_REASONS.find(
    (reason) => reason.id === activity.data.reason.reason
  )?.label;

  const reason = reasonLabel ? i18n._(reasonLabel) : undefined;
  const otherReason =
    activity.data.reason.reason === 'other' ? activity.data.reason.otherReason : undefined;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconInfo />}
      type="neutral"
      message={
        <BaseActivityText>
          <Trans id="activities.request_handling_fee_waived.message">
            <strong>{creatorName}</strong> didn't apply the handling fee for this request
          </Trans>
          {!!reason && (
            <>
              . <Trans id="activities.request_handling_fee_waived.reason">Reason:</Trans>{' '}
              <strong>{reason}</strong>
            </>
          )}
        </BaseActivityText>
      }
    >
      {!!otherReason && <BaseActivityDetailedContent>{otherReason}</BaseActivityDetailedContent>}
    </BaseActivity>
  );
};
